import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetPopup, IGetPopups, IPopupParams } from '../models/popup.model';
import QueryString from 'qs';

const uri = '/mgmt/popup';

export const getPopups = (campusCode: string, params: IPopupParams): AxiosPromise<IGetPopups> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/${campusCode}?${qsParams}`);
};

export const getPopup = (campusCode: string, popupCode: number): AxiosPromise<IGetPopup> => {
  return axios.get(`${uri}/${campusCode}/${popupCode}`);
};

export const createPopup = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updatePopup = (campusCode: string, popupCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}/${popupCode}`, data);
};

export const deletePopup = (campusCode: string, popupCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${campusCode}/${popupCode}`);
};
